import { render, staticRenderFns } from "./LiveBulletChat.vue?vue&type=template&id=5c039ff9&scoped=true"
import script from "./LiveBulletChat.vue?vue&type=script&lang=js"
export * from "./LiveBulletChat.vue?vue&type=script&lang=js"
import style0 from "./LiveBulletChat.vue?vue&type=style&index=0&id=5c039ff9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c039ff9",
  null
  
)

export default component.exports